import { useContext, useEffect, useMemo } from "react";
import { UserContext } from "../components/auth/auth-context";

export const useAuthStatus = () => {
  const { providerUser } = useContext(UserContext);

  
  const isLoggedIn = useMemo(() => {
    return !!providerUser?.userId;
  }, [providerUser]);

useEffect(() => {
  console.log("👀 isLoggedIn changed:", isLoggedIn);
}, [isLoggedIn]);
  
  
  return {
    isLoggedIn,
    providerUser,
  };
};
